import React, { useCallback, useEffect, useContext, useState } from "react";
import AppContext from "../../../AppContext";
import { getLookUpTable } from "../../../networking/Networking";
import { executeGenericReport } from "../../../networking/NetworkingReports";
import AlertBox from "../../shared/AlertBox";
import NewEditableGrid from "../../shared/NewEditableGrid";
import DynamicSelect from "../../shared/DynamicSelect";
import NewReportForm from "./NewReportForm";
import { Breadcrumb } from "antd";

export default function NewReports() {
    const appContext = useContext(AppContext);
    
    const [showAlert, setShowAlert] = useState(false);
    const [showAlertError, setShowAlertError] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');

    const [reportType, setReportType] = useState('');
    const [query, setQuery] = useState('');
    const [reportTypeDropdown, setReportTypeDropdown] = useState([]);

    const [showFields, setShowFields] = useState([]);
    const [fields, setFields] = useState(null);

    const [isValidated, setIsValidated] = useState(false);
    const [validateFields, setValidateFields] = useState(true);
    const [errors, setErrors] = useState([]);

    const [orders, setOrders] = useState([]);
    const [columnDetail, setColumnDetail] = useState({});
    
    const [forceReload, setForceReload] = useState(false);

    
    useEffect(() => {
        const loadData = async () => {
            const json = await getLookUpTable("Report Types BNotes");
            if (json) {
                const table = json.lookUpTables[0].lookUpTableDetails.map(item => ({
                    ...item,
                    value: item.LookUpTableDetail,
                    name: item.LookUpTableDetail
                }));

                setReportTypeDropdown(table);
            }
        }
        
        loadData();
    }, [])

    const cleanFields = useCallback(() => {
        setShowAlert(false);
        setAlertTitle('');
        setAlertMessage('');
        setReportType('');
        setShowFields([]);
        setFields(null);
        setIsValidated(false);
        setValidateFields(true);
        setErrors([]);
    }, []);

    const handleGetReportsClick = useCallback(async () => {
        if (!reportType || !query) {

            setShowAlertError(true);
            setAlertTitle("Error");
            setAlertMessage("Please select a report type");
            return;
        }
        
        if (!isValidated) {

            setShowAlertError(true);
            setAlertTitle("Error");
            setAlertMessage("Please fix the following errors:");
            setValidateFields(false);

            return;
        }
        const json = await executeGenericReport(query, fields);
        
        if(json && Number(json.httpStatusCode) === 200){
            let columnDetail = JSON.parse(json.columnDetail);
            let orders = json.result;                    
            setOrders(orders);
            setColumnDetail(columnDetail);
        }
        else {
            setShowAlertError(true);
            setAlertTitle("Error");
            setAlertMessage("An error occurred while trying to generate the report. Please try again.");
        }   
    }, [reportType, fields, isValidated, appContext]);
    
    const handleResetFieldsClick = () => {
        setForceReload(prev => !prev);
    };

    const handleGetFields = (values) => {
        setFields(values);
    };
    
    const validate = (validator) => {
        if (validator.valid) {

            setIsValidated(true);
            setValidateFields(true);
            setErrors([]);

        } else {

            setIsValidated(false);
            setErrors(validator.errors);

        }
    };
    
    const closeAlert = () => {
        setShowAlert(false);
        setAlertMessage('');
        setAlertTitle('');
        setValidateFields(true);
        cleanFields();
    };
    
    const closeAlertError = () => {
        setShowAlertError(false);
        setAlertMessage('');
        setAlertTitle('');
        setValidateFields(true);
    };
    
    const handleGetValueReportType = (value) => {

        let fieldsToShow = [];
        let query = "";

        if (value.value && value.value !== "select") {
            fieldsToShow = value.Field4.split(",");
            query = value.Field1;
        }

        setReportType(value.value);
        setShowFields(fieldsToShow);
        setQuery(query);
    };
    
    return(
        <div className="uk-margin-xlarge-bottom">
            <div className="breadcrumb-div">
                <Breadcrumb separator=">">
                    <Breadcrumb.Item className="breadcrumb-item-bold">
                        Reports
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <DynamicSelect 
                data={reportTypeDropdown}
                objValue={{ value: reportType, name: reportType }}
                getValue={handleGetValueReportType}
                listHasPlaceholder
                placeholder="Select an Item..."
                id="report-type"/>

            <NewReportForm
                fields={showFields}
                getFields={handleGetFields}
                isValid={validate}
                validated={validateFields}
                forceReload={forceReload}/>
            
            <div>
                {reportType &&
                    <button
                        className="uk-button uk-button-green"
                        onClick={handleResetFieldsClick}>
                        Reset Fields
                    </button>
                }

                <button
                    className="uk-button uk-button-green"
                    onClick={handleGetReportsClick}>
                    Get Reports
                </button>

            </div>

            <NewEditableGrid
                data={orders}
                columnDetails={columnDetail}
                isEditable={false}         
                useIcons={false}
                useExportButton={true}
                hiddenHeaders={'CustomerID'}/>

            <AlertBox
                open={showAlertError}
                onClose={closeAlertError}
                title={alertTitle}
                message={alertMessage}
                messageBoldList={errors}
                type="Ok"
                okClick={closeAlertError}/>

            <AlertBox
                open={showAlert}
                onClose={closeAlert}
                title={alertTitle}
                message={alertMessage}
                type="Ok"
                okClick={closeAlert}/>
        </div>
    )
}